import React from 'react';
import { CalendarIcon, ClockIcon, MapPinIcon } from 'lucide-react';
export function ElectionDetails() {
  return <div className="w-full pt-12 md:pt-16" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-1368">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-1369">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5" data-id="element-1370">
          <div className="bg-white rounded-xl p-5 shadow-sm border flex flex-col items-center text-center" style={{
          borderColor: '#ede9e0'
        }} data-id="element-1371">
            <div className="w-12 h-12 rounded-full flex items-center justify-center mb-3" style={{
            backgroundColor: 'rgba(30,61,47,0.08)'
          }} data-id="element-1372">
              <CalendarIcon size={24} style={{
              color: '#1e3d2f'
            }} data-id="element-1373" />
            </div>
            <h3 className="text-lg font-bold uppercase mb-1" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#1e3d2f'
          }} data-id="element-1374">
              Date
            </h3>
            <p className="text-base font-semibold" style={{
            color: '#1e3d2f',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-1375">
              Tuesday, January 27, 2026
            </p>
          </div>

          <div className="bg-white rounded-xl p-5 shadow-sm border flex flex-col items-center text-center" style={{
          borderColor: '#ede9e0'
        }} data-id="element-1376">
            <div className="w-12 h-12 rounded-full flex items-center justify-center mb-3" style={{
            backgroundColor: 'rgba(30,61,47,0.08)'
          }} data-id="element-1377">
              <ClockIcon size={24} style={{
              color: '#1e3d2f'
            }} data-id="element-1378" />
            </div>
            <h3 className="text-lg font-bold uppercase mb-1" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#1e3d2f'
          }} data-id="element-1379">
              Time
            </h3>
            <p className="text-base font-semibold" style={{
            color: '#1e3d2f',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-1380">
              7:00 PM
            </p>
          </div>

          <div className="bg-white rounded-xl p-5 shadow-sm border flex flex-col items-center text-center" style={{
          borderColor: '#ede9e0'
        }} data-id="element-1381">
            <div className="w-12 h-12 rounded-full flex items-center justify-center mb-3" style={{
            backgroundColor: 'rgba(30,61,47,0.08)'
          }} data-id="element-1382">
              <MapPinIcon size={24} style={{
              color: '#1e3d2f'
            }} data-id="element-1383" />
            </div>
            <h3 className="text-lg font-bold uppercase mb-1" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#1e3d2f'
          }} data-id="element-1384">
              Location
            </h3>
            <p className="text-base font-semibold" style={{
            color: '#1e3d2f',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-1385">
              FLSC Clubhouse Hall
            </p>
          </div>
        </div>
      </div>
    </div>;
}